module.exports = __webpack_public_path__ + "static/sport/bgi-pc.fb2f0c1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/sport/bgi-pc.jpg
// module id = H3Vr
// module chunks = 0